import Nav from "./../Page/Share/Nav/Nav";
const Post14 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            The Black Stallion Movie Poster
          </h2>
          {/* items?.Description */}
          <p>

          </p>
          {/* img section */}
          <img src="https://cdn.dribbble.com/users/6827497/screenshots/18189325/media/dbe0d5ca8e74a7228b821e78983f3a78.jpg" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post14;
